import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

export default class PhoneOperations {
  static fixPhonePrefix(phone: string): string {
    // sanity check, parsePhoneNumberFromString needs a '+' prefix ...
    if (phone.startsWith('00')) {
      return `+${phone.substring(2)}`;
    } else if (!phone.startsWith('+')) {
      return `+${phone}`;
    }
    return phone;
  }

  static validPhone(phonePrefix: undefined | string, phoneNumber: undefined | string, type?: string): boolean {
    if (phonePrefix && phoneNumber) {
      const combinedPhoneNumber: string = this.fixPhonePrefix(`${phonePrefix}${phoneNumber}`);
      const parsedPhone: any = parsePhoneNumberFromString(combinedPhoneNumber);
      let isValid: boolean;
      try {
        isValid = parsedPhone.isValid() && (!type || parsedPhone.getType() === type);
      } catch (error) {
        isValid = false;
      }
      return isValid;
    }
    return false;
  }

  static getPhone(phone: string, type?: string): null | string {
    if (phone) {
      const combinedPhoneNumber: string = this.fixPhonePrefix(phone);
      const parsedPhone: any = parsePhoneNumberFromString(combinedPhoneNumber);
      let isValid: boolean;
      try {
        isValid = parsedPhone.isValid() && (!type || parsedPhone.getType() === type);
      } catch (error) {
        isValid = false;
      }
      return isValid ? parsedPhone.formatInternational() : null;
    }
    return null;
  }

  static splitPhone(phone: string, type?: string): null | { phonePrefix: string; phoneNumber: string } {
    if (phone) {
      const combinedPhoneNumber: string = this.fixPhonePrefix(phone);
      const parsedPhone: any = parsePhoneNumberFromString(combinedPhoneNumber);
      let isValid: boolean;
      try {
        isValid = parsedPhone.isValid() && (!type || parsedPhone.getType() === type);
      } catch (error) {
        isValid = false;
      }
      return isValid
        ? { phonePrefix: '+' + parsedPhone.countryCallingCode, phoneNumber: parsedPhone.nationalNumber }
        : null;
    }
    return null;
  }

  static combinePhone(
    phonePrefix: undefined | string,
    phoneNumber: undefined | string,
    type?: string
  ): undefined | string {
    const combinedPhoneNumber: string = this.fixPhonePrefix(`${phonePrefix}${phoneNumber}`);
    const parsedPhone: any = parsePhoneNumberFromString(combinedPhoneNumber);
    try {
      if (parsedPhone.isValid() && (!type || parsedPhone.getType() === type)) {
        return parsedPhone.formatInternational();
      }
    } catch (error) {
      return undefined;
    }
  }
}
